@if (newTemplate) {
  <app-agent-confirmation
    [image]="confirmation.image"
    [header]="confirmation.header"
    [message]="
      (agents$ | async)?.length > 0 ? confirmation.agentMessage : confirmation.advisorMessage
    "
    [primaryButtonName]="confirmation.primaryButton"
    [secondaryButtonName]="confirmation.secondaryButton"
    [agents]="agents$ | async"
    (primaryButtonClicked)="done()"
    (secondaryButtonClicked)="requestAnotherChange()"
  ></app-agent-confirmation>
} @else {
  @if (!!(confirmationData | async)) {
    <div class="row margin-top-30">
      <ds-confirmation [confirmationData]="confirmationData | async">
        <ds-confirmation-link-area>
          <div class="row column twelve">
            <call-to-action
              [displayBackButton]="false"
              primaryButtonName="Done"
              (primaryEvent)="done()"
            ></call-to-action>
          </div>
        </ds-confirmation-link-area>
      </ds-confirmation>
    </div>
  }
}
